import React from "react";
import { useDroppable } from "@dnd-kit/core";
import "./Droppable.css";

const Droppable = ({ children }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: "droppable"
  });

  return (
    <div ref={setNodeRef} className={`droppable ${isOver ? "droppable-over" : ""}`}>
      {children} 
    </div>
  );
}

export default Droppable;
